import { render, staticRenderFns } from "./point-list-page.vue?vue&type=template&id=d7a0d3d4&"
import script from "./point-list-page.vue?vue&type=script&lang=ts&"
export * from "./point-list-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports